var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V20H15V5.5L9.5 0H0Z",
    fill: "#2B579A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H9.5V0L15 5.5Z",
    fill: "#A8C4E3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1.8,
    y: 14.5,
    fontSize: 4.2,
    fontFamily: "Arial, sans-serif",
    fill: "white",
    fontWeight: "bold"
  }, "DOCX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxIcon);
export default __webpack_public_path__ + "static/media/docxIcon.3216abb20268e9473a035aefc022e3ce.svg";
export { ForwardRef as ReactComponent };